import React from 'react';
import './RewardModal.css';
import { RewardModalProps } from '../types';

const RewardModal: React.FC<RewardModalProps> = ({
  isOpen,
  onClose,
  title,
  body1,
  body2,
  image,
  footer,
  onImageClick
}) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="reward-modal-overlay" onClick={handleOverlayClick}>
      <div className="reward-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="reward-modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="reward-modal-content">
          <h2 className="reward-modal-title">{title}</h2>
          
          <div className="reward-modal-body">
            <p className="reward-modal-body1">{body1}</p>
            {body2 && <p className="reward-modal-body2">{body2}</p>}
          </div>
          
          {(image && image != '')  && (
            <div className="reward-modal-image-container">
              <img 
                src={image} 
                alt="Reward" 
                className={`reward-modal-image ${onImageClick ? 'clickable' : ''}`}
                onClick={onImageClick}
                style={{ cursor: onImageClick ? 'pointer' : 'default' }}
              />
            </div>
          )}
          
          <p className="reward-modal-footer">{footer}</p>
        </div>
      </div>
    </div>
  );
};

export default RewardModal;
